import { Container, PremiumFeature, Tag } from "@fluidattacks/design";
import _ from "lodash";
import * as React from "react";

import { translate } from "utils/translations/translate";

interface ITechnique {
  readonly technique: string;
  readonly isAdvanced: boolean;
}

const Technique: React.FC<ITechnique> = ({
  technique,
  isAdvanced,
}: ITechnique): JSX.Element => {
  const labels: Record<string, string> = {
    CSPM: translate.t("searchFindings.tabVuln.technique.cspm"),
    DAST: translate.t("searchFindings.tabVuln.technique.dast"),
    PTAAS: translate.t("searchFindings.tabVuln.technique.ptaas"),
    RE: translate.t("searchFindings.tabVuln.technique.re"),
    SAST: translate.t("searchFindings.tabVuln.technique.sast"),
    SCA: translate.t("searchFindings.tabVuln.technique.sca"),
    SCR: translate.t("searchFindings.tabVuln.technique.scr"),
  };
  const formatedTechnique: string = _.toUpper(labels[technique]);
  const advancedTechniques = ["RE", "SCR", "PTAAS"];

  return (
    <Container alignItems={"center"} display={"flex"} gap={0.25}>
      <Tag tagLabel={formatedTechnique} variant={"inactive"} />
      {advancedTechniques.includes(technique) && !isAdvanced && (
        <PremiumFeature />
      )}
    </Container>
  );
};

const techniqueFormatter = (
  value: string,
  isAdvanced: boolean,
): JSX.Element => {
  return <Technique isAdvanced={isAdvanced} technique={value} />;
};

export type { ITechnique };
export { techniqueFormatter, Technique };
